/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const deleteDataSchema = z.object({
  deleted: z.literal(true),
});

export interface IDeleteSocialChannelV1Data {
  deleted: true;
}

export const deleteSocialChannelV1ResponseSchema = createApiResponseSchema(
  deleteDataSchema,
) as z.ZodSchema<IAPI<IDeleteSocialChannelV1Data>>;

export type IDeleteSocialChannelV1Response = IAPI<IDeleteSocialChannelV1Data>;
